export enum DamageReportSeverity {
  Minor = 'DamageSeverity.Minor',
  Moderate = 'DamageSeverity.Moderate',
  Severe = 'DamageSeverity.Severe',
}

export const DamageReportSeverityId: Record<DamageReportSeverity, number> = {
  [DamageReportSeverity.Minor]: 1,
  [DamageReportSeverity.Moderate]: 2,
  [DamageReportSeverity.Severe]: 3,
};
